// extracted by mini-css-extract-plugin
module.exports = {"notice":"JobNotice_notice__RwElR","title":"JobNotice_title__aKeGP","items":"JobNotice_items__kC4Y2"};